

















import Vue from 'vue';
import { format, sub } from 'date-fns';
import WbDatePicker from '@/components/date_picker/index.vue';
import WbTable from '@/components/table/index.vue';
import { Metrics } from './types';
import getMetrics from './dependencies/get_metrics';

export default Vue.extend({

  components: {
    WbDatePicker,
    WbTable,
  },

  data() {
    return {
      metrics: [] as Metrics[],
      table: {
        headers: [
          { text: '# of days delinquent', align: 'start', value: 'daysDelinquent' },
          { text: 'Sent', value: 'sentEmails' },
          { text: 'Recovery Rate', value: 'recoveryRate' },
          { text: 'Amount Recovered', value: 'recoveredAmountInDollars' },
        ],
      },
    };
  },

  async mounted() {
    const startDate = format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd');
    const endDate = format(new Date(), 'yyyy-MM-dd');
    this.metrics = await getMetrics(startDate, endDate);
  },

  methods: {
    async updateDate(dates: string[]) {
      const [startDate, endDate] = dates;
      this.metrics = await getMetrics(startDate, endDate);
    },
  },
});
